import { render, staticRenderFns } from "./assign-tabs.vue?vue&type=template&id=2dc47640&scoped=true&"
import script from "./assign-tabs.vue?vue&type=script&lang=js&"
export * from "./assign-tabs.vue?vue&type=script&lang=js&"
import style0 from "./assign-tabs.vue?vue&type=style&index=0&id=2dc47640&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc47640",
  null
  
)

export default component.exports